function DateToPersianNumber(num) {
  if(num){
    const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    let parts = num.split(" ");
    if (parts.length > 1) {
      let partsDate = parts[0].split("/");
      if (partsDate.length > 1) {
        let partsDatePersian = [];
        partsDate.forEach((element) => {
          partsDatePersian.push(
            element
              .toString()
              .split("")
              .map((x) => farsiDigits[x])
              .join("")
          );
        });
        partsDatePersian = partsDatePersian.join("/");
        let partsTime = parts[1].split(":");
        let partTimePersian = [];
        partsTime.forEach((element) => {
          partTimePersian.push(
            element
              .toString()
              .split("")
              .map((x) => farsiDigits[x])
              .join("")
          );
        });
        partTimePersian = partTimePersian.join(":");
        return partTimePersian + " " + partsDatePersian;
      } else {
        partsDate = parts[0].split("-");
        let partsDatePersian = [];
        partsDate.forEach((element) => {
          partsDatePersian.push(
            element
              .toString()
              .split("")
              .map((x) => farsiDigits[x])
              .join("")
          );
        });
        partsDatePersian = partsDatePersian.join("-");
        let partsTime = parts[1].split(":");
        let partTimePersian = [];
        partsTime.forEach((element) => {
          partTimePersian.push(
            element
              .toString()
              .split("")
              .map((x) => farsiDigits[x])
              .join("")
          );
        });
        partTimePersian = partTimePersian.join(":");
        return partTimePersian + " " + partsDatePersian;
      }
    } else {
      let partsDate = parts[0].split("/");
      if (partsDate.length > 1) {
        let partsDatePersian = [];
        partsDate.forEach((element) => {
          partsDatePersian.push(
            element
              .toString()
              .split("")
              .map((x) => farsiDigits[x])
              .join("")
          );
        });
        partsDatePersian = partsDatePersian.join("/");
  
        return partsDatePersian;
      } else {
        partsDate = parts[0].split("-");
        let partsDatePersian = [];
        partsDate.forEach((element) => {
          partsDatePersian.push(
            element
              .toString()
              .split("")
              .map((x) => farsiDigits[x])
              .join("")
          );
        });
        partsDatePersian = partsDatePersian.join("-");
  
        return partsDatePersian;
      }
    }
  }else{
    return num;
  }
 
}
export default DateToPersianNumber;
